import { Table } from 'shared/components'
import { TournamentLogoCell } from './components/tournamentLogoCell'
import { TeamCellComponent } from './components/teamCell'

export const createColumns = () => [
  {
    Header: 'TOURNAMENT',
    accessor: 'tournament',
    Cell: TournamentLogoCell,
    minWidth: 100,
    width: 100,
  },
  {
    Header: 'Team',
    id: 'teamA',
    accessor: 'teamA',
    Cell: TeamCellComponent,
    minWidth: 204,
  },
  {
    Header: 'Team',
    id: 'teamB',
    accessor: 'teamB',
    Cell: TeamCellComponent,
    minWidth: 204,
  },
  {
    Header: 'Date',
    accessor: 'eventTime',
    Cell: Table.CellRenderers.DateTimeCell,
    minWidth: 200,
    width: 200,
  },
  {
    Header: 'Total amount raised',
    accessor: 'amountRaised',
    Cell: Table.CellRenderers.MoneyValueCell,
    minWidth: 80,
  },
  {
    Header: 'Total amount benefited',
    accessor: 'amountBenefited',
    Cell: Table.CellRenderers.MoneyValueCell,
    minWidth: 80,
  },
]
